import React from 'react';
import ClientPanel from './client-panel';
import QuotePanel from './quote-panel';
import ErrorPage from './error-page';
import { BookingProvider, useBookingData } from '../context/BookingContext';

// Inner component that uses the booking context
const BookingContent = () => {
    const { loadError } = useBookingData();

    return (
        <div>
            {loadError ?
                <ErrorPage /> :
                <div className="flex flex-col lg:flex-row min-h-screen">
                    <ClientPanel />
                    <QuotePanel />
                </div>
            }
        </div>
    );
};

// Main component that provides the booking context
const Booking = () => {
    return (
        <BookingProvider>
            <BookingContent />
        </BookingProvider>
    );
};

export default Booking;
